<div class="box">
  <div class="box-row header">
    <app-header-bar [title]="'workflow_data_store.title'"></app-header-bar>
  </div>
  <div class="content mt-2 mb-3">
    <app-datatable
      [dataSource]="source"
      [columns]="columns"
      [identifier]="'workflow-data-stores'"
      [actionNew]="canWriteDataConnections"
      [customActions]="customActions"
      (newEvent)="new()"
      (showEvent)="show($event.valueOf())"
    >
      <app-empty-table
        [icon]="'hub'"
        [emptyText]="'workflow_data_store.empty_text' | translate"
        [buttonText]="
          canWriteDataConnections ? ('createNew' | translate) : undefined
        "
        (btnClick)="new()"
      >
      </app-empty-table>
    </app-datatable>

    <app-error [error]="error"></app-error>
  </div>
</div>
